import { useMemo } from 'react';
import { StyleSheet } from 'react-native';
import { useColors } from '../../hooks/useColors';
import { useScale } from '../../hooks/useScale';
import theme from '../../common/theme';

const CourseCallHeaderStyles = (isCalled = false) => {
  const { colors } = useColors();
  const { scale } = useScale();

  return useMemo(
    () =>
      StyleSheet.create({
        container: {
          flexDirection: 'row',
          alignItems: 'center',
          columnGap: scale(16),
          paddingLeft: scale(16),
          marginBottom: scale(4),
          borderRadius: theme.radius.s,
          backgroundColor: isCalled
            ? colors.orangeTransparent
            : colors.transparent,
          borderWidth: 1,
          borderColor: isCalled ? colors.deepOrange : colors.grey6,
          overflow: 'hidden',
        },
        name: {
          flex: 1,
          flexDirection: 'row',
          alignItems: 'center',
          columnGap: scale(8),
        },
        rightAlignedText: {
          textAlign: 'right',
        },
        title: {
          flex: 1,
          fontSize: scale(14),
          lineHeight: scale(20),
          fontFamily: theme.fonts.medium,
          color: isCalled ? colors.text : colors.textLight,
          fontVariant: ['tabular-nums'],
        },
        subtitle: {
          fontSize: scale(13),
          lineHeight: scale(16),
          fontFamily: theme.fonts.semibold,
          color: colors.white,
          fontVariant: ['tabular-nums'],
        },
        accessory: {
          height: scale(40),
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'center',
          columnGap: scale(4),
          paddingVertical: scale(6),
          paddingHorizontal: scale(isCalled ? 12 : 16),
          backgroundColor: isCalled ? colors.deepOrange : colors.grey6,
        },
      }),
    [colors, scale, isCalled],
  );
};

export default CourseCallHeaderStyles;
